import { NgModule, Injectable } from '@angular/core';
import { Routes, RouterModule, DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { Utilities } from './services/utilities';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth-guard.service';

import { WEBSITE_ROUTES } from './routes/televisa-website.routes';
import { WebLayoutComponent } from './components/Website/web-layout/web-layout.component';



@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        const possibleSeparators = /[?;#]/;
        const indexOfSeparator = url.search(possibleSeparators);
        let processedUrl: string;

        if (indexOfSeparator > -1) {
            const separator = url.charAt(indexOfSeparator);
            const urlParts = Utilities.splitInTwo(url, separator);
            urlParts.firstPart = urlParts.firstPart.toLowerCase();

            processedUrl = urlParts.firstPart + separator + urlParts.secondPart;
        } else {
            processedUrl = url.toLowerCase();
        }

        return super.parse(processedUrl);
    }
}


const routes: Routes = [
  { path: '', component: WebLayoutComponent, data: { title: 'Televisa' }, children: WEBSITE_ROUTES }
  /*{ path: '**', component: NotFoundComponent, data: { title: 'Page Not Found' } }*/
];


@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [
        AuthService,
        AuthGuard,
        { provide: UrlSerializer, useClass: LowerCaseUrlSerializer }]
})
export class AppRoutingModule { }
